import React from 'react';
import { useDispatch } from 'react-redux';
import mapJson from 'jsonpath-mapper';
import BlockListingStyled from './BlockListing.styled';
import BlockCard from '@/components/cards/BlockCard';
import LoadingSpinner from '@/components/loadingSpinner/LoadingSpinner';
import ErrorNote from '@/components/errorNote/ErrorNote';
import { VersionsPanelMappings } from '@/components/toolbar/Toolbar.mapper';
import { actions, ISelectedBlock } from '@/redux/slices/app';
import { Block, PanelTypes } from '@/types/Panel.types';

interface BlocksPanelProps {
  blocks: any[];
  loading?: boolean;
  error?: boolean;
  setPanel: (v: PanelTypes) => void;
}

const BlockListing = ({
  setPanel,
  blocks,
  loading,
  error,
}: BlocksPanelProps) => {
  const dispatch = useDispatch();
  const setSelectedBlock = (e: any, block: Block) => {
    e.preventDefault();
    const selectedBlock = mapJson(
      block,
      VersionsPanelMappings
    ) as ISelectedBlock;
    setPanel(PanelTypes.Version);
    dispatch(actions.SET_SELECTED_BLOCK({ selectedBlock }));
  };

  return (
    <BlockListingStyled>
      {loading && (
        <div className="block-panel__loading">
          <LoadingSpinner />
        </div>
      )}
      {error && (
        <ErrorNote
          title="An error occurred"
          text="You do not have permission to view blocks."
        />
      )}
      {blocks?.length >= 1 && (
        <ul>
          <h2 className="sr-only">Block listing</h2>
          {blocks?.map((block: any, i: number) => {
            return (
              <BlockCard
                {...block}
                key={i}
                action={(e: any) => setSelectedBlock(e, block)}
              />
            );
          })}
        </ul>
      )}
    </BlockListingStyled>
  );
};

export default BlockListing;
